let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("b8oHe")).then(() => parcelRequire('1Q21q'));